import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { Integration } from 'signup-constants/Integration';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
const IntegratedAppAuthorizationErrorView = ({
  errorKey,
  endpointKey,
  buttonMessageKey,
  titleMessageKey
}) => {
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(retryEndpoint(endpointKey)), [dispatch, endpointKey]);
  return /*#__PURE__*/_jsx(StandardError, {
    buttonMessageKey: buttonMessageKey,
    errorKey: errorKey,
    handleButtonClick: handleButtonClick,
    imageURL: imageUrls.computerError,
    titleMessageKey: titleMessageKey
  });
};
const withIntegration = WrappedComponent => {
  return () => {
    const integrationName = getIntegrationKey();
    let errorKey;
    let endpointKey;
    let buttonMessageKey;
    let titleMessageKey;
    switch (integrationName) {
      case Integration.ShopifyEmbedded:
        errorKey = ErrorKey.IntegratedAppAuthorizationError;
        endpointKey = EndpointKey.ShopifyEmbeddedAuthorization;
        break;
      case Integration.GoogleWorkspaceApp:
        errorKey = ErrorKey.IntegratedAppAuthorizationError;
        endpointKey = EndpointKey.GoogleWorkspaceAppAuthorization;
        buttonMessageKey = `error.${errorKey}.${integrationName}.button`;
        titleMessageKey = `error.${errorKey}.${integrationName}.title`;
        break;
      case Integration.Wordpress:
      default:
        errorKey = ErrorKey.WordpressAuthorizationError;
        endpointKey = EndpointKey.WordpressAuthorization;
        break;
    }
    buttonMessageKey = buttonMessageKey && isValidI18nKey(buttonMessageKey) ? buttonMessageKey : `error.${errorKey}.buttonCTA`;
    titleMessageKey = titleMessageKey && isValidI18nKey(titleMessageKey) ? titleMessageKey : `error.${errorKey}.title`;
    return /*#__PURE__*/_jsx(WrappedComponent, {
      buttonMessageKey: buttonMessageKey,
      endpointKey: endpointKey,
      errorKey: errorKey,
      titleMessageKey: titleMessageKey
    });
  };
};
export default withIntegration(IntegratedAppAuthorizationErrorView);